import { get, post, put } from "./apiHelper";
import { flattenFilters } from "./utilHelper";
import { TListParams } from "~/types/global";
import {
  GetOrderResponse,
  GetUserResponse,
  GetVidRequestResponse,
  GetOrderESignContractsResponse,
  GetOrderInkSignContractsResponse,
  GetOrderDocResponse,
  GetOrderDocSignersResponse,
  GetOrderDocSigningsResponse,
  GetOrderFinancialContractsResponse,
  GetOrderShippingResponse,
  GetMessageTemplatesChannelResponse,
  SignOrderDocRequest,
} from "~/types/backend";

const getEntityList = (url: string, params: TListParams) => get(url, { params: flattenFilters(params) });

// User

// Disable caching for the auth user endpoint
// This is necessary because the auth user endpoint need to be un-cached each time
// so we can see if something has changed in the user data
export const getAuthUser = () => get<GetUserResponse>('/me', {
  headers: {
    'Cache-Control': 'no-cache, no-store, must-revalidate',
    'Pragma': 'no-cache',
    'Expires': '0'
  }
});

export const getAuthUserSignatures = () => get<{ signatures: unknown[] }>('/me/signatures');

export const goIdle = () => put('/me/idle');

export const goActive = () => put('/me/active');

// Vid Request

export const getVidRequest = () => get<GetVidRequestResponse>(`/vid-request`);

export const uploadImages = (data: FormData, config?: { onUploadProgress?: (e: unknown) => void }) => post(`/vid-request/upload`, data, config);

export const retryVid = () => post<{ id: number }>(`/vid-request/retry`);

// Order

export const getOrder = () => get<GetOrderResponse>(`/order`);

export const getOrderInkSignContracts = () => get<GetOrderInkSignContractsResponse>(`/order/docs/ink-sign`);

export const getOrderESignContracts = () => get<GetOrderESignContractsResponse>(`/order/docs/e-sign`);

export const getOrderFinancialContracts = () => get<GetOrderFinancialContractsResponse>(`/order/docs/finance`);

export const uploadContractPage = (data: { pageImg: Blob | string }, pageId: number, id: number) => post(`/order-doc/${id}/page/${pageId}`, data);

export const uploadOrderDocPage = (data: FormData, id: number, page: number) => post(`/order-doc/${id}/page/${page}`, data);

export const createOrderMeeting = (role: string | number) => post<{ link: string }>(`/order/meet/${role}`);

export const acceptNotaryAppointment = () => put('/order/accept-notary-appointment');

export const logSignerOpenedInsuranceLink = () => post('/order/signer-link/clicked');

export const declineNotaryAppointment = (data?: { reason: string }) => put('/order/decline-notary-appointment', data);

export const eSignConsent = () => post<{ id: number }>('/order/docs/e-sign/consent');

export const updatePaperCopyRequired = (data: { isPaperCopyRequired: boolean }) => post('/order/docs/e-sign/paper-copy', data);

export const submitSqueezeVerification = (data: unknown) => put('/order/squeeze/verification', data);

export const updateCustomerInsuranceStatus = (data: unknown) => put('/order/insurance', data);

export const updateCustomerSqueezeId = (data: unknown) => put('/order/insurance/squeezeId', data);

export const getOrderRequiredDocSignatureTypes = () => get<{ requiredSignatureTypes?: number[] }>(`/order/docs/e-sign/required-signature-types`);

// Fedex and UPS

export const getOrderShipping = () => get<GetOrderShippingResponse>(`/order/track/shipping`);

// OrderDoc

export const getOrderDoc = (id: number) => get<GetOrderDocResponse>(`/order-doc/${id}`);

export const signOrderDoc = (data: SignOrderDocRequest, id: number) => put<{ id: number }>(`/order-doc/${id}/sign`, data);

export const getOrderDocSigners = (orderDocId: number) => get<GetOrderDocSignersResponse>(`/order-doc/${orderDocId}/signers`);

export const getOrderDocSignings = (orderDocId: number) => get<GetOrderDocSigningsResponse>(`/order-doc/${orderDocId}/signings`);

export const instantSignOrderDoc = (docId: number, data: { signatures: unknown }) => put(`/order-doc/${docId}/instant-sign`, data);

// Verify User

export const generateCode = (isResend: boolean) => post(`/me/security-code/generate?resend=${isResend ? 1 : 0}`)

export const verifyCode = (code: string) => post<{ token: string }>(`/me/security-code/check`, { code })

// Messages

export const getMessages = (channelId: string | number, params: TListParams = {}) => getEntityList(`/messages/${channelId}`, params);

export const createMessage = (data: any, config?: any) => post('/message', data, config);

// Second form of ID

export const uploadSecondForOfId = (data: FormData | Record<string, unknown>) => post(`/order/second-id/upload`, data);

// Message template

export const getMessageTemplatesChannel = (channelId: number) => get<GetMessageTemplatesChannelResponse>(`/message-templates/${channelId}`);